import React, { useEffect, useState } from 'react'
import './landing.css'
import C2wSuperxLandingBottom from '../landingBottom/landingBottom';
import C2wSuperxVideoSrc from '../../../common/C2wSuperxHome/videoSrc/videoSrc';
import { Swiper, SwiperSlide } from 'swiper/react';
import 'swiper/css';
import 'swiper/css/pagination';
import "swiper/css/navigation";
import { Autoplay, Navigation, Pagination } from 'swiper/modules';
import C2wSuperxlogoHld from '../../../common/C2wSuperxHome/landing/logoHld';
import C2wTechLogoHolder from '../../../common/C2wSuperxHome/landing/techLogoHolder';
import { Helmet } from 'react-helmet';


function C2wSuperxLanding() {
    const [swiperInstance, setSwiperInstance] = useState(null);
    const arr1 = [
        { imageName: 'Api', title: 'API' },
        { imageName: 'aws', title: 'AWS' },
        { imageName: 'firebase', title: 'Firebase' },
        { imageName: 'postman', title: 'Postman' },
        { imageName: 'gcp', title: 'GCP' },
        { imageName: 'git', title: 'Git' },
    ]

    const arr2 = [
        { imageName: 'vscode', title: 'VS Code' },
        { imageName: 'glade', title: 'Glade' },
        { imageName: 'aurdino', title: 'Arduino' },
        { imageName: 'esp', title: 'ESP32' },
        { imageName: 'raspberrypi', title: 'Raspberry Pi' },
        { imageName: 'devops', title: 'DevOps' },
        { imageName: 'rabbitmq', title: 'RabbitMQ' },
        { imageName: 'thingspeak', title: 'ThingSpeak' }
    ]

    const arr3 = [
        { imageName: 'javafx', title: 'Java FX' },
        { imageName: 'maven', title: 'Maven' },
        { imageName: 'pyqt', title: 'PyQt' },
        { imageName: 'tkinter', title: 'Tkinter' },
        { imageName: 'gtk', title: 'GTK' },
        { imageName: 'opencv', title: 'Open CV' },
    ]

    /**
 * @constant renderedTechnology1
 * @author Vishal Lohbande
 *
 * Description:
 * - Maps over `arr1` array to render a list of `C2wTechLogoHolder` components.
 * - Passes each object in the array as a prop named `obj`.
 * - Sets the `type` prop to `0` for each rendered component.
 *
 * Usage:
 * - Used to display technology logos or items stored in `arr1`.
 *
 * Notes:
 * - Consider adding a unique `key` prop for React list rendering optimization.
 */
    const renderedTechnology1 = arr1?.map((obj) => {
        return <C2wTechLogoHolder obj={obj} type={0} />
    })

    /**
 * @constant renderedTechnology2
 * @author Vishal Lohbande
 *
 * Description:
 * - Maps over `arr2` array to render a list of `C2wTechLogoHolder` components.
 * - Passes each object in the array as the `obj` prop.
 * - Sets the `type` prop to `1` for each rendered component.
 *
 * Usage:
 * - Used to display a different category or type of technology logos/items from `arr2`.
 *
 * Notes:
 * - Adding a unique `key` prop is recommended to optimize React rendering.
 */
    const renderedTechnology2 = arr2?.map((obj) => {
        return <C2wTechLogoHolder obj={obj} type={1} />
    })

    /**
 * @constant renderedTechnology3
 * @author Vishal Lohbande
 *
 * Description:
 * - Maps over `arr3` array to render a list of `C2wTechLogoHolder` components.
 * - Passes each object in the array as the `obj` prop.
 * - Sets the `type` prop to `0` for each rendered component.
 *
 * Usage:
 * - Used to display technology logos or items stored in `arr3`.
 *
 * Notes:
 * - It's recommended to add a unique `key` prop for each item to optimize React rendering.
 */
    const renderedTechnology3 = arr3?.map((obj) => {
        return <C2wTechLogoHolder obj={obj} type={0} />
    })


    /**
 * @state videoSource
 * @function handleTheVideo
 * @author Vishal Lohbande
 *
 * Description:
 * - Maintains the current video source path in the state `videoSource`.
 * - Updates the video source based on the active swiper slide index.
 *
 * Behavior:
 * - If the swiper's `realIndex` is between 4 and 5 (inclusive), sets the video source to 'classvideo2.mp4'.
 * - For all other indices, resets the video source to 'classvideo.mp4'.
 *
 * Usage:
 * - Useful for dynamically switching videos based on user navigation in a swiper/carousel component.
 */
    const [videoSource, setVideoSource] = useState('/assets/superx/videos/SuperxVideo.mp4');
    const [videoSourceMobile, setVideoSourceMobile] = useState('/assets/superx/videos/SuperxVideoMobileView.mp4')
    // const handleTheVideo = (swiper) => {
    //     if (swiper?.realIndex > 3 && swiper.realIndex <= 5) {
    //         setVideoSource('/assets/superx/videos/classvideo2.mp4');
    //     } else {
    //         setVideoSource('/assets/superx/videos/classvideo.mp4'); // Ensure it resets when out of range
    //     }
    // };


    /**
 * @hook useEffect - Sync video source state
 * @author Vishal Lohbande
 *
 * Description:
 * - Runs every time `videoSource` state changes.
 * - Currently calls `setVideoSource` with the existing `videoSource` value.
 * - This effect appears redundant unless side effects or external syncing is intended.
 */
    useEffect(() => {
        setVideoSource(videoSource)
    }, [videoSource])

    /**
 * @hook useEffect - Window resize listener to track window width
 * @author Vishal Lohbande
 *
 * Description:
 * - Adds a resize event listener on window.
 * - Updates the `windowWidth` state whenever the window is resized.
 * - Cleans up event listener on component unmount.
 */
    const [windowWidth, setWindowWidth] = useState(window.innerWidth);
    useEffect(() => {
        const handleResize = () => {
            setWindowWidth(window.innerWidth);
        };

        window.addEventListener('resize', handleResize);
        return () => window.removeEventListener('resize', handleResize);
    }, []);

    return (
        windowWidth > 620 ? (
        <div className='C2wSuperxLanding_ctn'>
                  <Helmet>
                    <title>Core2web - Learn Coding Languages & Full Stack Development</title>
                     <meta name="description"
                        content="Core2web - Learn Coding Languages & Full Stack Development." />
                    <meta name="robots" content="index, follow" />
            
                  </Helmet>
            <C2wSuperxVideoSrc videoSource={videoSource} />
            <C2wSuperxlogoHld />
            <div className='C2wSuperxLanding_Swiper_ctn'>
                <Swiper
                    pagination={{
                        dynamicBullets: true,
                    }}
                    modules={[Autoplay, Pagination, Navigation]}
                    // onSlideChange={handleTheVideo}
                    onSwiper={setSwiperInstance}
                    className="mySwiper"
                    navigation={true}
                    loop={true}
                    autoplay={{
                        delay:5000,
                        disableOnInteraction: false,
                    }}
                >
                    <SwiperSlide className='C2wSuperx_slide_text'>
                        <div className='C2wSuperx_slide_middleCtn' >
                            <div className='C2wSuperx_slide_middleCtn_stop' 
                            // onMouseEnter={() => swiperInstance?.autoplay?.stop()}
                            // onMouseLeave={() => swiperInstance.autoplay?.start()}
                            >
                            <div className='C2wSuperx_slide_heading'>{' A project presentation platform,'}</div>
                            <div className='C2wSuperx_slide_subheading'>{'where you develop'}</div>
                            <div className='C2wSuperx_slide_mainheading'>
                                <span className='spantechnical'>{'Technical '}</span>
                                {'Skills & '}
                                <span className='spansoft' >{'Soft '}</span>{'Skills.'}
                            </div>
                            </div>
                        {/* </div> */}
                        </div>
                    </SwiperSlide>
                    <SwiperSlide className='C2wSuperx_slide'>
                    <div className='C2wSuperx_slide_middleCtn'> 
                    <div className='C2wSuperx_slide_middleCtn_stop' 
                            // onMouseEnter={() => swiperInstance?.autoplay?.stop()}
                            // onMouseLeave={() => swiperInstance.autoplay?.start()}
                            >                 
                            <div className='C2wSuperx2_slide_crdholder'>
                                 <div className='C2wSuperx2_slide_heading '>
                                {'You get to learn more about Concepts & Tools.'}
                            </div>
                                <div className='C2wSuperx2_slide_crdholder_div1'>{renderedTechnology1}</div>
                                <div className='C2wSuperx2_slide_crdholder_div2'>{renderedTechnology2}</div>
                            </div>
                            </div>
                        </div>
                    </SwiperSlide>
                     <SwiperSlide className='C2wSuperx_slide'>
                     <div className='C2wSuperx_slide_middleCtn'>
                     <div className='C2wSuperx_slide_middleCtn_stop' 
                            // onMouseEnter={() => swiperInstance?.autoplay?.stop()}
                            // onMouseLeave={() => swiperInstance.autoplay?.start()}
                            >  
                            <div className='C2wSuperx2_slide_crdholder3'>
                            <div className='C2wSuperx2_slide_headingslide3 '>
                                {'Libraries & Frameworks we explore through this Journey'}
                            </div>
                                <div className='C2wSuperx2_slide_crdholder_div1'>{renderedTechnology3}</div>
                            </div>
                        </div>
                        </div>
                    </SwiperSlide>

                        <SwiperSlide className='C2wSuperx_slide_text'>
                            <div className='C2wSuperx_slide_middleCtn'>
                                <div className='C2wSuperx_slide_middleCtn_stop'
                                    // onMouseEnter={() => swiperInstance?.autoplay?.stop()}
                                    // onMouseLeave={() => swiperInstance.autoplay?.start()}
                                >
                                    <div className='C2wSuperx_slide_text_div_content'>
                                        <div className='C2wSuperx_slide_heading2'>{'Pitch your idea '}<span>{'in front of industry experts,'}</span></div>
                                        <div className='C2wSuperx_slide_heading2'><span>{'Start your'}</span></div>
                                        <div className='C2wSuperx_slide_mainheading'>
                                            <span className='spantechnical'>{'Entrepreneurship  '}</span>
                                            {'Journey.'}
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </SwiperSlide>
                        <SwiperSlide className='C2wSuperx_slide_text'>
                            <div className='C2wSuperx_slide_middleCtn'>
                                <div className='C2wSuperx_slide_middleCtn_stop'
                                    // onMouseEnter={() => swiperInstance?.autoplay?.stop()}
                                    // onMouseLeave={() => swiperInstance.autoplay?.start()}
                                >
                                    <div className='C2wSuperx_slide_text_div_content'>
                                        <div className='C2wSuperx_slide_mainheadingslide5'>
                                            <span style={{ fontWeight: 700 }} className='spansoft' >{'Every doer is a winner'}</span>
                                        </div>
                                        <div className='C2wSuperx_slide_heading' style={{ fontWeight: 400 }}>{'Participate, excel, and get rewarded with exclusive'}</div>
                                        <div className='C2wSuperx_slide_mainheading'>
                                            <span className='spantechnical'>{'Completion certificate'}</span>
                                        </div>
                                        <div className='C2wSuperx_slide_heading' style={{ fontWeight: 400 }}>{'for your project.'}</div>
                                    </div>
                                </div>
                            </div>
                        </SwiperSlide>

                        <SwiperSlide className='C2wSuperx_slide_text'>
                            <div className='C2wSuperx_slide_middleCtn'>
                                <div className='C2wSuperx_slide_middleCtn_stop'
                                    // onMouseEnter={() => swiperInstance?.autoplay?.stop()}
                                    // onMouseLeave={() => swiperInstance.autoplay?.start()}
                                >
                                    <div className='C2wSuperx_slide_text_div_content'>
                                        <div style={{ fontWeight: 500 }} className='C2wSuperx_slide_heading'>{'The more you do, the more you win!'}</div>
                                        <div className='C2wSuperx_slide_heading' style={{ fontWeight: 400 }} >{'We celebrate Winners with'}</div>
                                        <div className='C2wSuperx_slide_mainheading'>
                                            {'amazing '}
                                            <span className='spantechnical'>{'Prizes '}</span>
                                            {'& exciting'}
                                            <span className='spansoft' >{' Goodies!'}</span>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </SwiperSlide>
                    </Swiper>
                </div>
                <C2wSuperxLandingBottom />
            </div>) :
            (
                <div className='C2wSuperxLanding_ctn'>
                    <C2wSuperxVideoSrc videoSource={videoSourceMobile} />
                    <C2wSuperxlogoHld />
                    <div className='C2wSuperxLanding_Swiper_ctn'>
                        <Swiper
                            pagination={{
                                dynamicBullets: true,
                            }}
                            modules={[Pagination, Navigation, Autoplay]}
                            // onSlideChange={handleTheVideo}
                            onSwiper={setSwiperInstance}
                            className="mySwiper"
                            navigation={true}
                            loop={true}
                            autoplay={{
                                delay: 5000,
                                disableOnInteraction: false,
                            }}
                        >
                            <SwiperSlide className='C2wSuperx_slide_text'>
                                <div className='C2wSuperx_slide_middleCtn' >
                                    <div className='C2wSuperx_slide_middleCtn_stop'
                                    >
                                        <div className='C2wSuperx_slide_heading'>{' A project presentation platform,'}</div>
                                        <div className='C2wSuperx_slide_subheading'>{'where you develop'}</div>
                                        <div className='C2wSuperx_slide_mainheading'>
                                            <span className='spantechnical'>{'Technical '}</span>
                                            {'Skills'}
                                        </div>
                                        <div className='C2wSuperx_slide_mainheading'>{'&'}</div>
                                        <div className='C2wSuperx_slide_mainheading'>

                                            <span className='spansoft' >{'Soft '}</span>{'Skills.'}
                                        </div>
                                    </div>
                                </div>
                            </SwiperSlide>
                            <SwiperSlide className='C2wSuperx_slide'>
                                <div className='C2wSuperx_slide_middleCtn'>
                                    <div className='C2wSuperx_slide_middleCtn_stop'
                                        // onMouseEnter={() => swiperInstance?.autoplay?.stop()}
                                        // onMouseLeave={() => swiperInstance.autoplay?.start()}
                                    >
                                        <div className='C2wSuperx2_slide_crdholder'>
                                            <div className='C2wSuperx2_slide_heading '>
                                                {'You get to know more about Concepts & Tools'}
                                            </div>
                                            <div className='C2wSuperx2_slide_crdholder_div1'>{renderedTechnology1}</div>
                                            <div className='C2wSuperx2_slide_crdholder_div2'>{renderedTechnology2}</div>
                                        </div>
                                    </div>
                                </div>
                            </SwiperSlide>
                            <SwiperSlide className='C2wSuperx_slide'>
                                <div className='C2wSuperx_slide_middleCtn'>
                                    <div className='C2wSuperx_slide_middleCtn_stop'
                                        // onMouseEnter={() => swiperInstance?.autoplay?.stop()}
                                        // onMouseLeave={() => swiperInstance.autoplay?.start()}
                                    >
                                        <div className='C2wSuperx2_slide_crdholder3'>
                                            <div className='C2wSuperx2_slide_headingslide3 '>
                                                {'Libraries & Frameworks we explore through this Journey'}
                                            </div>
                                            <div className='C2wSuperx2_slide_crdholder_div1_mobile'>{renderedTechnology3}</div>
                                        </div>
                                    </div>
                                </div>
                            </SwiperSlide>

                            <SwiperSlide className='C2wSuperx_slide_text'>
                                <div className='C2wSuperx_slide_middleCtn'>
                                    <div className='C2wSuperx_slide_middleCtn_stop'
                                        // onMouseEnter={() => swiperInstance?.autoplay?.stop()}
                                        // onMouseLeave={() => swiperInstance.autoplay?.start()}
                                    >
                                        <div className='C2wSuperx_slide_text_div_content'>
                                            <div className='C2wSuperx_slide_heading2'>{'Pitch your idea '}</div>
                                            <div className='C2wSuperx_slide_heading2'><span>{'in front of industry experts,'}</span></div>

                                            <div className='C2wSuperx_slide_mainheading'>
                                                <div className='C2wSuperx_slide_heading2'>
                                                    <span>{'Start your'}</span>
                                                </div>
                                                <span className='spantechnical'>{'Entrepreneurship  '}</span>
                                                {'Journey.'}
                                            </div>
                                        </div>
                                    </div>

                                </div>
                            </SwiperSlide>

                            <SwiperSlide className='C2wSuperx_slide_text'>
                                <div className='C2wSuperx_slide_middleCtn'>
                                    <div className='C2wSuperx_slide_middleCtn_stop'
                                        // onMouseEnter={() => swiperInstance?.autoplay?.stop()}
                                        // onMouseLeave={() => swiperInstance.autoplay?.start()}
                                    >
                                        <div className='C2wSuperx_slide_text_div_content'>
                                            <div className='C2wSuperx_slide_mainheadingslide5'>
                                                <span style={{ fontWeight: 700 }} className='spansoft' >{'Every doer is a winner'}</span>
                                            </div>
                                            <div className='C2wSuperx_slide_heading' style={{ fontWeight: 400 }}>{'Participate, excel, and get rewarded with exclusive'}</div>
                                            <div className='C2wSuperx_slide_mainheading'>
                                                <span className='spantechnical'>{'Completion certificate'}</span>
                                            </div>
                                            <div className='C2wSuperx_slide_heading' style={{ fontWeight: 400 }}>{'for your project.'}</div>
                                        </div>
                                    </div>
                                </div>
                            </SwiperSlide>

                            <SwiperSlide className='C2wSuperx_slide_text'>
                                <div className='C2wSuperx_slide_middleCtn'>
                                    <div className='C2wSuperx_slide_middleCtn_stop'
                                        // onMouseEnter={() => swiperInstance?.autoplay?.stop()}
                                        // onMouseLeave={() => swiperInstance.autoplay?.start()}
                                    >
                                        <div className='C2wSuperx_slide_text_div_content'>
                                            <div style={{ fontWeight: 500 }} className='C2wSuperx_slide_heading'>{'The more you do, the more you win!'}</div>
                                            <div className='C2wSuperx_slide_heading' style={{ fontWeight: 400 }} >{'We celebrate Winners with'}</div>
                                            <div className='C2wSuperx_slide_mainheading'>
                                                {'amazing '}
                                                <span className='spantechnical'>{'Prizes '}</span>

                                            </div>
                                            <div className='C2wSuperx_slide_mainheading'>{'&'}</div>
                                            <div className='C2wSuperx_slide_mainheading'>
                                                {'exciting'}
                                                <span className='spansoft' >{' Goodies!'}</span>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </SwiperSlide>
                        </Swiper>
                    </div>
                    <C2wSuperxLandingBottom />
                </div>
            )
    )
}

export default C2wSuperxLanding;
